import { ComponentsOverrides } from "@mui/material"

export const createMuiCheckboxOverrides = (selectedPalette: any): ComponentsOverrides['MuiCheckbox'] => ({
    root: {
        '&:hover': {
            color: selectedPalette.primary[40],
            backgroundColor: 'transparent'
        },
        '&.Mui-focusVisible': {
            outline: 'none'
        },
        '&.Mui-checked': {
            color: selectedPalette.primary[40]
        },
        '& rect': {
            strokeWidth: 0.5
        },
        '&:hover rect': {
            strokeWidth: 1
        }
    },
    colorPrimary: () => ({
        '&.Mui-checked': {
            color: selectedPalette.primary[40]
        }
    }),
    colorSecondary: () => ({
        '&.Mui-checked': {
            color: selectedPalette.secondary[40]
        }
    })
})